import classNames from "classnames";
import React, { forwardRef, memo } from "react";
import "./Typography.scss";

export const TYPOGRAPHY_VARIANTS = {
	XL10: "xl10",
	XL9: "xl9",
	XL8: "xl8",
	XL7: "xl7",
	XL6: "xl6",
	XL5: "xl5",
	XL4: "xl4",
	XL3: "xl3",
	XL2: "xl2",
	XL: "xl",
	LARGE: "large",
	REGULAR: "regular",
	SMALL: "small",
	XSMALL: "xsmall",
	XXSMALL: "xxsmall",
} as const;

type TypographyVariant = (typeof TYPOGRAPHY_VARIANTS)[keyof typeof TYPOGRAPHY_VARIANTS];

type TypographyProps = {
	variant?: TypographyVariant;
	variantMC?: TypographyVariant;
	variantSM?: TypographyVariant;
	variantMD?: TypographyVariant;
	variantLG?: TypographyVariant;
	isBold?: boolean;
	isUnderline?: boolean;
	component?: keyof React.JSX.IntrinsicElements;
	"data-testid"?: string;
} & React.HTMLAttributes<HTMLElement>;

const Typography = forwardRef<HTMLElement, TypographyProps>(
	(
		{
			variant,
			variantMC,
			variantSM,
			variantMD,
			variantLG,
			isBold,
			isUnderline,
			component,
			children,
			className,
			"data-testid": dataTestId,
			...props
		},
		ref
	) => {
		const Component = (component || "div") as React.ElementType;
		const typoClass = classNames(
			{
				[`typography--${variant}${isBold ? "-bold" : ""}`]: variant,
				[`typography--mc-${variantMC}${isBold ? "-bold" : ""}`]: variantMC,
				[`typography--sm-${variantSM}${isBold ? "-bold" : ""}`]: variantSM,
				[`typography--md-${variantMD}${isBold ? "-bold" : ""}`]: variantMD,
				[`typography--lg-${variantLG}${isBold ? "-bold" : ""}`]: variantLG,
				"typography--underline": isUnderline,
			},
			className
		);

		return (
			<Component className={typoClass} {...props} ref={ref} data-testid={dataTestId}>
				{children}
			</Component>
		);
	}
);

Typography.displayName = "Typography";

export default memo(Typography);
